import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _22139184 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _73e24fc1 = () => interopDefault(import('../pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1b596bfe = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _ac3a22c6 = () => interopDefault(import('../pages/promotions/index.vue' /* webpackChunkName: "pages/promotions/index" */))
const _1ea48840 = () => interopDefault(import('../pages/properties/index.vue' /* webpackChunkName: "pages/properties/index" */))
const _4941f601 = () => interopDefault(import('../pages/properties-list/index.vue' /* webpackChunkName: "pages/properties-list/index" */))
const _5071b424 = () => interopDefault(import('../pages/quotes/index.vue' /* webpackChunkName: "pages/quotes/index" */))
const _5b5cee63 = () => interopDefault(import('../pages/sorry.vue' /* webpackChunkName: "pages/sorry" */))
const _51d139a3 = () => interopDefault(import('../pages/book/confirmed.vue' /* webpackChunkName: "pages/book/confirmed" */))
const _18c8e8ea = () => interopDefault(import('../pages/book/credit-card-confirmation.vue' /* webpackChunkName: "pages/book/credit-card-confirmation" */))
const _5a2d4312 = () => interopDefault(import('../pages/portal/checkin/index.vue' /* webpackChunkName: "pages/portal/checkin/index" */))
const _abf307c4 = () => interopDefault(import('../pages/portal/contract/index.vue' /* webpackChunkName: "pages/portal/contract/index" */))
const _98c0fb6a = () => interopDefault(import('../pages/portal/guestbook/index.vue' /* webpackChunkName: "pages/portal/guestbook/index" */))
const _65ade558 = () => interopDefault(import('../pages/portal/payment-method/index.vue' /* webpackChunkName: "pages/portal/payment-method/index" */))
const _c9ff2afa = () => interopDefault(import('../pages/portal/quotes/index.vue' /* webpackChunkName: "pages/portal/quotes/index" */))
const _2f0c6a73 = () => interopDefault(import('../pages/portal/reservations/index.vue' /* webpackChunkName: "pages/portal/reservations/index" */))
const _8981c7be = () => interopDefault(import('../pages/portal/transactions/index.vue' /* webpackChunkName: "pages/portal/transactions/index" */))
const _16596a33 = () => interopDefault(import('../pages/book/steps/ClientDetails.vue' /* webpackChunkName: "pages/book/steps/ClientDetails" */))
const _11460e52 = () => interopDefault(import('../pages/book/steps/Extras.vue' /* webpackChunkName: "pages/book/steps/Extras" */))
const _14375bc2 = () => interopDefault(import('../pages/book/steps/Payment.vue' /* webpackChunkName: "pages/book/steps/Payment" */))
const _28ee0162 = () => interopDefault(import('../pages/book/steps/Summary.vue' /* webpackChunkName: "pages/book/steps/Summary" */))
const _32791080 = () => interopDefault(import('../pages/portal/contract/signed.vue' /* webpackChunkName: "pages/portal/contract/signed" */))
const _1e39c210 = () => interopDefault(import('../pages/portal/quotes/confirmed.vue' /* webpackChunkName: "pages/portal/quotes/confirmed" */))
const _785ad8dd = () => interopDefault(import('../pages/portal/quotes/credit-card-confirmation.vue' /* webpackChunkName: "pages/portal/quotes/credit-card-confirmation" */))
const _129d1a26 = () => interopDefault(import('../pages/portal/reservations/credit-card-confirmation.vue' /* webpackChunkName: "pages/portal/reservations/credit-card-confirmation" */))
const _1ad38ce1 = () => interopDefault(import('../pages/book/steps/mixins/confirmation.js' /* webpackChunkName: "pages/book/steps/mixins/confirmation" */))
const _56ab6692 = () => interopDefault(import('../pages/book/steps/partials/ExtraCard.vue' /* webpackChunkName: "pages/book/steps/partials/ExtraCard" */))
const _219d0a86 = () => interopDefault(import('../pages/book/steps/paymentMethods/bankTransfer.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/bankTransfer" */))
const _0d42973f = () => interopDefault(import('../pages/book/steps/paymentMethods/cardNowNexi.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/cardNowNexi" */))
const _3cb4be64 = () => interopDefault(import('../pages/book/steps/paymentMethods/cardNowStripe.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/cardNowStripe" */))
const _68ddbf1c = () => interopDefault(import('../pages/book/steps/paymentMethods/cash.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/cash" */))
const _5719f6a8 = () => interopDefault(import('../pages/book/steps/paymentMethods/creditCard.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/creditCard" */))
const _0375fa52 = () => interopDefault(import('../pages/book/steps/paymentMethods/creditCardSecom.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/creditCardSecom" */))
const _5b2ef895 = () => interopDefault(import('../pages/book/steps/paymentMethods/creditCardStripe.vue' /* webpackChunkName: "pages/book/steps/paymentMethods/creditCardStripe" */))
const _2fd999c9 = () => interopDefault(import('../pages/portal/checkin/mixins/form.js' /* webpackChunkName: "pages/portal/checkin/mixins/form" */))
const _21c834a2 = () => interopDefault(import('../pages/portal/quotes/steps/Payment.vue' /* webpackChunkName: "pages/portal/quotes/steps/Payment" */))
const _03d28b4f = () => interopDefault(import('../pages/portal/quotes/steps/Summary.vue' /* webpackChunkName: "pages/portal/quotes/steps/Summary" */))
const _7a657cd4 = () => interopDefault(import('../pages/portal/quotes/steps/mixins/confirmation.js' /* webpackChunkName: "pages/portal/quotes/steps/mixins/confirmation" */))
const _277e5bf3 = () => interopDefault(import('../pages/portal/quotes/steps/paymentMethods/bankTransfer.vue' /* webpackChunkName: "pages/portal/quotes/steps/paymentMethods/bankTransfer" */))
const _0f02c22a = () => interopDefault(import('../pages/portal/quotes/steps/paymentMethods/cardNow.vue' /* webpackChunkName: "pages/portal/quotes/steps/paymentMethods/cardNow" */))
const _5e3d2edf = () => interopDefault(import('../pages/portal/quotes/steps/paymentMethods/cash.vue' /* webpackChunkName: "pages/portal/quotes/steps/paymentMethods/cash" */))
const _45c79e4a = () => interopDefault(import('../pages/portal/quotes/steps/paymentMethods/creditCardSecom.vue' /* webpackChunkName: "pages/portal/quotes/steps/paymentMethods/creditCardSecom" */))
const _6232d39b = () => interopDefault(import('../pages/portal/manage/_company_id.vue' /* webpackChunkName: "pages/portal/manage/_company_id" */))
const _56a38313 = () => interopDefault(import('../pages/accommodation/_slug.vue' /* webpackChunkName: "pages/accommodation/_slug" */))
const _d082d904 = () => interopDefault(import('../pages/book/_id.vue' /* webpackChunkName: "pages/book/_id" */))
const _6a393648 = () => interopDefault(import('../pages/properties/_id.vue' /* webpackChunkName: "pages/properties/_id" */))
const _2c447510 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _22139184,
    name: "404___en"
  }, {
    path: "/cookie-policy",
    component: _73e24fc1,
    name: "cookie-policy___en"
  }, {
    path: "/de",
    component: _2dfb1658,
    name: "index___de"
  }, {
    path: "/fr",
    component: _2dfb1658,
    name: "index___fr"
  }, {
    path: "/it",
    component: _2dfb1658,
    name: "index___it"
  }, {
    path: "/privacy-policy",
    component: _1b596bfe,
    name: "privacy-policy___en"
  }, {
    path: "/promotions",
    component: _ac3a22c6,
    name: "promotions___en"
  }, {
    path: "/properties",
    component: _1ea48840,
    name: "properties___en"
  }, {
    path: "/properties-list",
    component: _4941f601,
    name: "properties-list___en"
  }, {
    path: "/quotes",
    component: _5071b424,
    name: "quotes___en"
  }, {
    path: "/sorry",
    component: _5b5cee63,
    name: "sorry___en"
  }, {
    path: "/book/confirmed",
    component: _51d139a3,
    name: "book-confirmed___en"
  }, {
    path: "/book/credit-card-confirmation",
    component: _18c8e8ea,
    name: "book-credit-card-confirmation___en"
  }, {
    path: "/de/404",
    component: _22139184,
    name: "404___de"
  }, {
    path: "/de/cookie-policy",
    component: _73e24fc1,
    name: "cookie-policy___de"
  }, {
    path: "/de/privacy-policy",
    component: _1b596bfe,
    name: "privacy-policy___de"
  }, {
    path: "/de/promotions",
    component: _ac3a22c6,
    name: "promotions___de"
  }, {
    path: "/de/properties",
    component: _1ea48840,
    name: "properties___de"
  }, {
    path: "/de/properties-list",
    component: _4941f601,
    name: "properties-list___de"
  }, {
    path: "/de/quotes",
    component: _5071b424,
    name: "quotes___de"
  }, {
    path: "/de/sorry",
    component: _5b5cee63,
    name: "sorry___de"
  }, {
    path: "/fr/404",
    component: _22139184,
    name: "404___fr"
  }, {
    path: "/fr/cookie-policy",
    component: _73e24fc1,
    name: "cookie-policy___fr"
  }, {
    path: "/fr/privacy-policy",
    component: _1b596bfe,
    name: "privacy-policy___fr"
  }, {
    path: "/fr/promotions",
    component: _ac3a22c6,
    name: "promotions___fr"
  }, {
    path: "/fr/properties",
    component: _1ea48840,
    name: "properties___fr"
  }, {
    path: "/fr/properties-list",
    component: _4941f601,
    name: "properties-list___fr"
  }, {
    path: "/fr/quotes",
    component: _5071b424,
    name: "quotes___fr"
  }, {
    path: "/fr/sorry",
    component: _5b5cee63,
    name: "sorry___fr"
  }, {
    path: "/it/404",
    component: _22139184,
    name: "404___it"
  }, {
    path: "/it/cookie-policy",
    component: _73e24fc1,
    name: "cookie-policy___it"
  }, {
    path: "/it/privacy-policy",
    component: _1b596bfe,
    name: "privacy-policy___it"
  }, {
    path: "/it/promotions",
    component: _ac3a22c6,
    name: "promotions___it"
  }, {
    path: "/it/properties",
    component: _1ea48840,
    name: "properties___it"
  }, {
    path: "/it/properties-list",
    component: _4941f601,
    name: "properties-list___it"
  }, {
    path: "/it/quotes",
    component: _5071b424,
    name: "quotes___it"
  }, {
    path: "/it/sorry",
    component: _5b5cee63,
    name: "sorry___it"
  }, {
    path: "/portal/checkin",
    component: _5a2d4312,
    name: "portal-checkin___en"
  }, {
    path: "/portal/contract",
    component: _abf307c4,
    name: "portal-contract___en"
  }, {
    path: "/portal/guestbook",
    component: _98c0fb6a,
    name: "portal-guestbook___en"
  }, {
    path: "/portal/payment-method",
    component: _65ade558,
    name: "portal-payment-method___en"
  }, {
    path: "/portal/quotes",
    component: _c9ff2afa,
    name: "portal-quotes___en"
  }, {
    path: "/portal/reservations",
    component: _2f0c6a73,
    name: "portal-reservations___en"
  }, {
    path: "/portal/transactions",
    component: _8981c7be,
    name: "portal-transactions___en"
  }, {
    path: "/book/steps/ClientDetails",
    component: _16596a33,
    name: "book-steps-ClientDetails___en"
  }, {
    path: "/book/steps/Extras",
    component: _11460e52,
    name: "book-steps-Extras___en"
  }, {
    path: "/book/steps/Payment",
    component: _14375bc2,
    name: "book-steps-Payment___en"
  }, {
    path: "/book/steps/Summary",
    component: _28ee0162,
    name: "book-steps-Summary___en"
  }, {
    path: "/de/book/confirmed",
    component: _51d139a3,
    name: "book-confirmed___de"
  }, {
    path: "/de/book/credit-card-confirmation",
    component: _18c8e8ea,
    name: "book-credit-card-confirmation___de"
  }, {
    path: "/de/portal/checkin",
    component: _5a2d4312,
    name: "portal-checkin___de"
  }, {
    path: "/de/portal/contract",
    component: _abf307c4,
    name: "portal-contract___de"
  }, {
    path: "/de/portal/guestbook",
    component: _98c0fb6a,
    name: "portal-guestbook___de"
  }, {
    path: "/de/portal/payment-method",
    component: _65ade558,
    name: "portal-payment-method___de"
  }, {
    path: "/de/portal/quotes",
    component: _c9ff2afa,
    name: "portal-quotes___de"
  }, {
    path: "/de/portal/reservations",
    component: _2f0c6a73,
    name: "portal-reservations___de"
  }, {
    path: "/de/portal/transactions",
    component: _8981c7be,
    name: "portal-transactions___de"
  }, {
    path: "/fr/book/confirmed",
    component: _51d139a3,
    name: "book-confirmed___fr"
  }, {
    path: "/fr/book/credit-card-confirmation",
    component: _18c8e8ea,
    name: "book-credit-card-confirmation___fr"
  }, {
    path: "/fr/portal/checkin",
    component: _5a2d4312,
    name: "portal-checkin___fr"
  }, {
    path: "/fr/portal/contract",
    component: _abf307c4,
    name: "portal-contract___fr"
  }, {
    path: "/fr/portal/guestbook",
    component: _98c0fb6a,
    name: "portal-guestbook___fr"
  }, {
    path: "/fr/portal/payment-method",
    component: _65ade558,
    name: "portal-payment-method___fr"
  }, {
    path: "/fr/portal/quotes",
    component: _c9ff2afa,
    name: "portal-quotes___fr"
  }, {
    path: "/fr/portal/reservations",
    component: _2f0c6a73,
    name: "portal-reservations___fr"
  }, {
    path: "/fr/portal/transactions",
    component: _8981c7be,
    name: "portal-transactions___fr"
  }, {
    path: "/it/book/confirmed",
    component: _51d139a3,
    name: "book-confirmed___it"
  }, {
    path: "/it/book/credit-card-confirmation",
    component: _18c8e8ea,
    name: "book-credit-card-confirmation___it"
  }, {
    path: "/it/portal/checkin",
    component: _5a2d4312,
    name: "portal-checkin___it"
  }, {
    path: "/it/portal/contract",
    component: _abf307c4,
    name: "portal-contract___it"
  }, {
    path: "/it/portal/guestbook",
    component: _98c0fb6a,
    name: "portal-guestbook___it"
  }, {
    path: "/it/portal/payment-method",
    component: _65ade558,
    name: "portal-payment-method___it"
  }, {
    path: "/it/portal/quotes",
    component: _c9ff2afa,
    name: "portal-quotes___it"
  }, {
    path: "/it/portal/reservations",
    component: _2f0c6a73,
    name: "portal-reservations___it"
  }, {
    path: "/it/portal/transactions",
    component: _8981c7be,
    name: "portal-transactions___it"
  }, {
    path: "/portal/contract/signed",
    component: _32791080,
    name: "portal-contract-signed___en"
  }, {
    path: "/portal/quotes/confirmed",
    component: _1e39c210,
    name: "portal-quotes-confirmed___en"
  }, {
    path: "/portal/quotes/credit-card-confirmation",
    component: _785ad8dd,
    name: "portal-quotes-credit-card-confirmation___en"
  }, {
    path: "/portal/reservations/credit-card-confirmation",
    component: _129d1a26,
    name: "portal-reservations-credit-card-confirmation___en"
  }, {
    path: "/book/steps/mixins/confirmation",
    component: _1ad38ce1,
    name: "book-steps-mixins-confirmation___en"
  }, {
    path: "/book/steps/partials/ExtraCard",
    component: _56ab6692,
    name: "book-steps-partials-ExtraCard___en"
  }, {
    path: "/book/steps/paymentMethods/bankTransfer",
    component: _219d0a86,
    name: "book-steps-paymentMethods-bankTransfer___en"
  }, {
    path: "/book/steps/paymentMethods/cardNowNexi",
    component: _0d42973f,
    name: "book-steps-paymentMethods-cardNowNexi___en"
  }, {
    path: "/book/steps/paymentMethods/cardNowStripe",
    component: _3cb4be64,
    name: "book-steps-paymentMethods-cardNowStripe___en"
  }, {
    path: "/book/steps/paymentMethods/cash",
    component: _68ddbf1c,
    name: "book-steps-paymentMethods-cash___en"
  }, {
    path: "/book/steps/paymentMethods/creditCard",
    component: _5719f6a8,
    name: "book-steps-paymentMethods-creditCard___en"
  }, {
    path: "/book/steps/paymentMethods/creditCardSecom",
    component: _0375fa52,
    name: "book-steps-paymentMethods-creditCardSecom___en"
  }, {
    path: "/book/steps/paymentMethods/creditCardStripe",
    component: _5b2ef895,
    name: "book-steps-paymentMethods-creditCardStripe___en"
  }, {
    path: "/de/book/steps/ClientDetails",
    component: _16596a33,
    name: "book-steps-ClientDetails___de"
  }, {
    path: "/de/book/steps/Extras",
    component: _11460e52,
    name: "book-steps-Extras___de"
  }, {
    path: "/de/book/steps/Payment",
    component: _14375bc2,
    name: "book-steps-Payment___de"
  }, {
    path: "/de/book/steps/Summary",
    component: _28ee0162,
    name: "book-steps-Summary___de"
  }, {
    path: "/de/portal/contract/signed",
    component: _32791080,
    name: "portal-contract-signed___de"
  }, {
    path: "/de/portal/quotes/confirmed",
    component: _1e39c210,
    name: "portal-quotes-confirmed___de"
  }, {
    path: "/de/portal/quotes/credit-card-confirmation",
    component: _785ad8dd,
    name: "portal-quotes-credit-card-confirmation___de"
  }, {
    path: "/de/portal/reservations/credit-card-confirmation",
    component: _129d1a26,
    name: "portal-reservations-credit-card-confirmation___de"
  }, {
    path: "/fr/book/steps/ClientDetails",
    component: _16596a33,
    name: "book-steps-ClientDetails___fr"
  }, {
    path: "/fr/book/steps/Extras",
    component: _11460e52,
    name: "book-steps-Extras___fr"
  }, {
    path: "/fr/book/steps/Payment",
    component: _14375bc2,
    name: "book-steps-Payment___fr"
  }, {
    path: "/fr/book/steps/Summary",
    component: _28ee0162,
    name: "book-steps-Summary___fr"
  }, {
    path: "/fr/portal/contract/signed",
    component: _32791080,
    name: "portal-contract-signed___fr"
  }, {
    path: "/fr/portal/quotes/confirmed",
    component: _1e39c210,
    name: "portal-quotes-confirmed___fr"
  }, {
    path: "/fr/portal/quotes/credit-card-confirmation",
    component: _785ad8dd,
    name: "portal-quotes-credit-card-confirmation___fr"
  }, {
    path: "/fr/portal/reservations/credit-card-confirmation",
    component: _129d1a26,
    name: "portal-reservations-credit-card-confirmation___fr"
  }, {
    path: "/it/book/steps/ClientDetails",
    component: _16596a33,
    name: "book-steps-ClientDetails___it"
  }, {
    path: "/it/book/steps/Extras",
    component: _11460e52,
    name: "book-steps-Extras___it"
  }, {
    path: "/it/book/steps/Payment",
    component: _14375bc2,
    name: "book-steps-Payment___it"
  }, {
    path: "/it/book/steps/Summary",
    component: _28ee0162,
    name: "book-steps-Summary___it"
  }, {
    path: "/it/portal/contract/signed",
    component: _32791080,
    name: "portal-contract-signed___it"
  }, {
    path: "/it/portal/quotes/confirmed",
    component: _1e39c210,
    name: "portal-quotes-confirmed___it"
  }, {
    path: "/it/portal/quotes/credit-card-confirmation",
    component: _785ad8dd,
    name: "portal-quotes-credit-card-confirmation___it"
  }, {
    path: "/it/portal/reservations/credit-card-confirmation",
    component: _129d1a26,
    name: "portal-reservations-credit-card-confirmation___it"
  }, {
    path: "/portal/checkin/mixins/form",
    component: _2fd999c9,
    name: "portal-checkin-mixins-form___en"
  }, {
    path: "/portal/quotes/steps/Payment",
    component: _21c834a2,
    name: "portal-quotes-steps-Payment___en"
  }, {
    path: "/portal/quotes/steps/Summary",
    component: _03d28b4f,
    name: "portal-quotes-steps-Summary___en"
  }, {
    path: "/de/book/steps/mixins/confirmation",
    component: _1ad38ce1,
    name: "book-steps-mixins-confirmation___de"
  }, {
    path: "/de/book/steps/partials/ExtraCard",
    component: _56ab6692,
    name: "book-steps-partials-ExtraCard___de"
  }, {
    path: "/de/book/steps/paymentMethods/bankTransfer",
    component: _219d0a86,
    name: "book-steps-paymentMethods-bankTransfer___de"
  }, {
    path: "/de/book/steps/paymentMethods/cardNowNexi",
    component: _0d42973f,
    name: "book-steps-paymentMethods-cardNowNexi___de"
  }, {
    path: "/de/book/steps/paymentMethods/cardNowStripe",
    component: _3cb4be64,
    name: "book-steps-paymentMethods-cardNowStripe___de"
  }, {
    path: "/de/book/steps/paymentMethods/cash",
    component: _68ddbf1c,
    name: "book-steps-paymentMethods-cash___de"
  }, {
    path: "/de/book/steps/paymentMethods/creditCard",
    component: _5719f6a8,
    name: "book-steps-paymentMethods-creditCard___de"
  }, {
    path: "/de/book/steps/paymentMethods/creditCardSecom",
    component: _0375fa52,
    name: "book-steps-paymentMethods-creditCardSecom___de"
  }, {
    path: "/de/book/steps/paymentMethods/creditCardStripe",
    component: _5b2ef895,
    name: "book-steps-paymentMethods-creditCardStripe___de"
  }, {
    path: "/de/portal/checkin/mixins/form",
    component: _2fd999c9,
    name: "portal-checkin-mixins-form___de"
  }, {
    path: "/de/portal/quotes/steps/Payment",
    component: _21c834a2,
    name: "portal-quotes-steps-Payment___de"
  }, {
    path: "/de/portal/quotes/steps/Summary",
    component: _03d28b4f,
    name: "portal-quotes-steps-Summary___de"
  }, {
    path: "/fr/book/steps/mixins/confirmation",
    component: _1ad38ce1,
    name: "book-steps-mixins-confirmation___fr"
  }, {
    path: "/fr/book/steps/partials/ExtraCard",
    component: _56ab6692,
    name: "book-steps-partials-ExtraCard___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/bankTransfer",
    component: _219d0a86,
    name: "book-steps-paymentMethods-bankTransfer___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/cardNowNexi",
    component: _0d42973f,
    name: "book-steps-paymentMethods-cardNowNexi___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/cardNowStripe",
    component: _3cb4be64,
    name: "book-steps-paymentMethods-cardNowStripe___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/cash",
    component: _68ddbf1c,
    name: "book-steps-paymentMethods-cash___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/creditCard",
    component: _5719f6a8,
    name: "book-steps-paymentMethods-creditCard___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/creditCardSecom",
    component: _0375fa52,
    name: "book-steps-paymentMethods-creditCardSecom___fr"
  }, {
    path: "/fr/book/steps/paymentMethods/creditCardStripe",
    component: _5b2ef895,
    name: "book-steps-paymentMethods-creditCardStripe___fr"
  }, {
    path: "/fr/portal/checkin/mixins/form",
    component: _2fd999c9,
    name: "portal-checkin-mixins-form___fr"
  }, {
    path: "/fr/portal/quotes/steps/Payment",
    component: _21c834a2,
    name: "portal-quotes-steps-Payment___fr"
  }, {
    path: "/fr/portal/quotes/steps/Summary",
    component: _03d28b4f,
    name: "portal-quotes-steps-Summary___fr"
  }, {
    path: "/it/book/steps/mixins/confirmation",
    component: _1ad38ce1,
    name: "book-steps-mixins-confirmation___it"
  }, {
    path: "/it/book/steps/partials/ExtraCard",
    component: _56ab6692,
    name: "book-steps-partials-ExtraCard___it"
  }, {
    path: "/it/book/steps/paymentMethods/bankTransfer",
    component: _219d0a86,
    name: "book-steps-paymentMethods-bankTransfer___it"
  }, {
    path: "/it/book/steps/paymentMethods/cardNowNexi",
    component: _0d42973f,
    name: "book-steps-paymentMethods-cardNowNexi___it"
  }, {
    path: "/it/book/steps/paymentMethods/cardNowStripe",
    component: _3cb4be64,
    name: "book-steps-paymentMethods-cardNowStripe___it"
  }, {
    path: "/it/book/steps/paymentMethods/cash",
    component: _68ddbf1c,
    name: "book-steps-paymentMethods-cash___it"
  }, {
    path: "/it/book/steps/paymentMethods/creditCard",
    component: _5719f6a8,
    name: "book-steps-paymentMethods-creditCard___it"
  }, {
    path: "/it/book/steps/paymentMethods/creditCardSecom",
    component: _0375fa52,
    name: "book-steps-paymentMethods-creditCardSecom___it"
  }, {
    path: "/it/book/steps/paymentMethods/creditCardStripe",
    component: _5b2ef895,
    name: "book-steps-paymentMethods-creditCardStripe___it"
  }, {
    path: "/it/portal/checkin/mixins/form",
    component: _2fd999c9,
    name: "portal-checkin-mixins-form___it"
  }, {
    path: "/it/portal/quotes/steps/Payment",
    component: _21c834a2,
    name: "portal-quotes-steps-Payment___it"
  }, {
    path: "/it/portal/quotes/steps/Summary",
    component: _03d28b4f,
    name: "portal-quotes-steps-Summary___it"
  }, {
    path: "/portal/quotes/steps/mixins/confirmation",
    component: _7a657cd4,
    name: "portal-quotes-steps-mixins-confirmation___en"
  }, {
    path: "/portal/quotes/steps/paymentMethods/bankTransfer",
    component: _277e5bf3,
    name: "portal-quotes-steps-paymentMethods-bankTransfer___en"
  }, {
    path: "/portal/quotes/steps/paymentMethods/cardNow",
    component: _0f02c22a,
    name: "portal-quotes-steps-paymentMethods-cardNow___en"
  }, {
    path: "/portal/quotes/steps/paymentMethods/cash",
    component: _5e3d2edf,
    name: "portal-quotes-steps-paymentMethods-cash___en"
  }, {
    path: "/portal/quotes/steps/paymentMethods/creditCardSecom",
    component: _45c79e4a,
    name: "portal-quotes-steps-paymentMethods-creditCardSecom___en"
  }, {
    path: "/de/portal/quotes/steps/mixins/confirmation",
    component: _7a657cd4,
    name: "portal-quotes-steps-mixins-confirmation___de"
  }, {
    path: "/de/portal/quotes/steps/paymentMethods/bankTransfer",
    component: _277e5bf3,
    name: "portal-quotes-steps-paymentMethods-bankTransfer___de"
  }, {
    path: "/de/portal/quotes/steps/paymentMethods/cardNow",
    component: _0f02c22a,
    name: "portal-quotes-steps-paymentMethods-cardNow___de"
  }, {
    path: "/de/portal/quotes/steps/paymentMethods/cash",
    component: _5e3d2edf,
    name: "portal-quotes-steps-paymentMethods-cash___de"
  }, {
    path: "/de/portal/quotes/steps/paymentMethods/creditCardSecom",
    component: _45c79e4a,
    name: "portal-quotes-steps-paymentMethods-creditCardSecom___de"
  }, {
    path: "/fr/portal/quotes/steps/mixins/confirmation",
    component: _7a657cd4,
    name: "portal-quotes-steps-mixins-confirmation___fr"
  }, {
    path: "/fr/portal/quotes/steps/paymentMethods/bankTransfer",
    component: _277e5bf3,
    name: "portal-quotes-steps-paymentMethods-bankTransfer___fr"
  }, {
    path: "/fr/portal/quotes/steps/paymentMethods/cardNow",
    component: _0f02c22a,
    name: "portal-quotes-steps-paymentMethods-cardNow___fr"
  }, {
    path: "/fr/portal/quotes/steps/paymentMethods/cash",
    component: _5e3d2edf,
    name: "portal-quotes-steps-paymentMethods-cash___fr"
  }, {
    path: "/fr/portal/quotes/steps/paymentMethods/creditCardSecom",
    component: _45c79e4a,
    name: "portal-quotes-steps-paymentMethods-creditCardSecom___fr"
  }, {
    path: "/it/portal/quotes/steps/mixins/confirmation",
    component: _7a657cd4,
    name: "portal-quotes-steps-mixins-confirmation___it"
  }, {
    path: "/it/portal/quotes/steps/paymentMethods/bankTransfer",
    component: _277e5bf3,
    name: "portal-quotes-steps-paymentMethods-bankTransfer___it"
  }, {
    path: "/it/portal/quotes/steps/paymentMethods/cardNow",
    component: _0f02c22a,
    name: "portal-quotes-steps-paymentMethods-cardNow___it"
  }, {
    path: "/it/portal/quotes/steps/paymentMethods/cash",
    component: _5e3d2edf,
    name: "portal-quotes-steps-paymentMethods-cash___it"
  }, {
    path: "/it/portal/quotes/steps/paymentMethods/creditCardSecom",
    component: _45c79e4a,
    name: "portal-quotes-steps-paymentMethods-creditCardSecom___it"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___en"
  }, {
    path: "/de/portal/manage/:company_id?",
    component: _6232d39b,
    name: "portal-manage-company_id___de"
  }, {
    path: "/fr/portal/manage/:company_id?",
    component: _6232d39b,
    name: "portal-manage-company_id___fr"
  }, {
    path: "/it/portal/manage/:company_id?",
    component: _6232d39b,
    name: "portal-manage-company_id___it"
  }, {
    path: "/de/accommodation/:slug?",
    component: _56a38313,
    name: "accommodation-slug___de"
  }, {
    path: "/de/book/:id?",
    component: _d082d904,
    name: "book-id___de"
  }, {
    path: "/de/properties/:id",
    component: _6a393648,
    name: "properties-id___de"
  }, {
    path: "/fr/accommodation/:slug?",
    component: _56a38313,
    name: "accommodation-slug___fr"
  }, {
    path: "/fr/book/:id?",
    component: _d082d904,
    name: "book-id___fr"
  }, {
    path: "/fr/properties/:id",
    component: _6a393648,
    name: "properties-id___fr"
  }, {
    path: "/it/accommodation/:slug?",
    component: _56a38313,
    name: "accommodation-slug___it"
  }, {
    path: "/it/book/:id?",
    component: _d082d904,
    name: "book-id___it"
  }, {
    path: "/it/properties/:id",
    component: _6a393648,
    name: "properties-id___it"
  }, {
    path: "/portal/manage/:company_id?",
    component: _6232d39b,
    name: "portal-manage-company_id___en"
  }, {
    path: "/accommodation/:slug?",
    component: _56a38313,
    name: "accommodation-slug___en"
  }, {
    path: "/book/:id?",
    component: _d082d904,
    name: "book-id___en"
  }, {
    path: "/de/:slug",
    component: _2c447510,
    name: "slug___de"
  }, {
    path: "/fr/:slug",
    component: _2c447510,
    name: "slug___fr"
  }, {
    path: "/it/:slug",
    component: _2c447510,
    name: "slug___it"
  }, {
    path: "/properties/:id",
    component: _6a393648,
    name: "properties-id___en"
  }, {
    path: "/:slug",
    component: _2c447510,
    name: "slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
